import { Button, Col, Collapse, DatePicker, Row, Select, Spin, AutoComplete, Tooltip, Switch, Card, Form, Checkbox } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { generateBlob } from "../../Utils/CreateBlob";
import { errHandler } from "../../helper/helper";
import './GeneralLedger.css';
import {
    generateAccountGl,
    generateLedgerBranchReport,
    generateLedgerBranchWiseReport,
    generateLedgerDistrictReport,
    generateLedgerDistrictWiseReport, getAllBranchesByDistrictName,
    getDistrictDivisionalBranchDetails, getAllDistrict,
    getAllLedgerHeaders, getDivAreaBranches,
    getAllTrailBalance,
    generateLedgerBranchWiseReportDistrict
} from "./GeneralLedgerService";
import { disabledDate } from "../../Utils/Util";
import jwt_decode from "jwt-decode";
import CustomFooter from "../../Layout/CustomFooter";
import LedgerBranchWise from "./LedgerBranchWise";
import PermissionPanel from "../../Layout/PermissionPanel";
import BookEntryList from "./BookEntryList";
import BookEntryDetails from "./BookEntryDetails";

const { Panel } = Collapse;
const { Option } = Select;
const glTypeOption = [
    {
        value: 0,
        label: "Asset"
    },
    {
        value: 1,
        label: "Control"
    },
    {
        value: 2,
        label: "Expense"
    },
    {
        value: 3,
        label: "Income"
    },
    {
        value: 4,
        label: "Liability"
    },
];

const createdData = (data) => {
    let convertedData = data.map((post) => {
        return {
            headerId: post.headerId,
            headerName: post.headerName,
            ledgerAccDtoList: post.ledgerAccDtoList.map(e => {
                return {
                    legId: e.legId,
                    legCode: e.legCode,
                    legName: e.legName
                }
            })
        }
    })
    return convertedData;
};

const createDistrictData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            districtId: post.districtId,
            districtName: post.districtName,
            districtCode: post.districtCode,
            provinceId: post.provinceId,
        }

    }))
    return convertedData;
};

const createdBranchData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            id: post.id,
            branchCode: post.branchCode,
            branchName: post.branchName,
            branchNumber: post.branchNumber,
            locked: post.locked,
            divisionalAreaId: post.divisionaAreaId,
        }

    }))
    return convertedData;
};

const createDivAreaData = (data) => {
    return (data.map((post) => {
        return {
            divAId: post.divAId,
            divAIdCode: post.divAIdCode,
            divAIdName: post.divAIdName,
            districtId: post.districtId,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }
    }));
};

const GeneralLodger = () => {
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(null);
    const [glType, setGlType] = useState(null);
    const [ledgerGlType, setLedgerGlType] = useState(null);
    const [headerData, setHeaderData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [selectedDistrictData, setSelectedDistrictData] = useState(null);
    const [selectedHeader, setSelectedHeader] = useState(null);
    const [selectedLedgerAcc, setSelectedLedgerAcc] = useState(null);
    const [glLoading, setGlLoading] = useState(false);
    const [glDistrictLoading, setGlDistrictLoading] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [isExcelLedgerReport, setIsExcelLedgerReport] = useState(false);
    const [isExcelGenLedgerReport, setIsExcelGenLedgerReport] = useState(false);
    const [isExcelGLReport, setIsExcelGLReport] = useState(false);
    const [isExcelGLTrialReport, setIsExcelGLTrialReport] = useState(false);
    const [divAreaData, setDivAreaData] = useState([]);
    const [selectedDivisionalArea, setSelectedDivisionalArea] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState("");
    const [selectedBranchGLReport, setSelectedBranchGLReport] = useState("");
    const [branchData, setBranchData] = useState([]);
    const [ledgerDate, setLedgerDate] = useState(null);
    const [ledgerLoading, setLedgerLoding] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [districtDivisionalBranchData, setDistrictDivisionalBranchData] = useState([]);




    const { RangePicker } = DatePicker;

    const token = localStorage.getItem("accessToken")
    const decodeToken = token ? jwt_decode(token) : null;

    const loginPlaceId = localStorage.getItem("placeId");
    const branchId = localStorage.getItem("branchId");
    const districtName = loginPlaceId === "4" ? decodeToken.districtName : null;
    const divisionalId = loginPlaceId === "2" ? decodeToken.divAId : " ";
    const branchName = loginPlaceId === "1" ? decodeToken.branch : " ";

    const handleDateChange = (dates) => {
        setSelectedDates(dates);
    };

    const handleLedgerDate = (value) => {
        setLedgerDate(value);
    }

    const handleChange = (value) => {
        setGlType(value);
    }

    const handleChangeLedgerReport = (value) => {
        setLedgerGlType(value);
    }


    const handleGlDistrictSelect = (value) => {
        setSelectedDistrictData(value);
        handleFilteredData(value)

    };
    const handleGlDistrict = (value) => {
        setSelectedDistrict(value);
        handleFilteredData(value)

    };

    const handleBranchChange = (value) => {
        setSelectedBranch(value);
    };

    const handleBranchChangeGLReport = (value) => {
        setSelectedBranchGLReport(value);
    };


    const handleFilteredData = (value) => {
        const filtered = districtData.filter((district) =>
            district.districtName.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered)
    };

    const handleHeaderChange = (value) => {
        setSelectedHeader(value);

        // Set the branch selection to the first branch of the selected district
        const selectedHeader = headerData.find((header) => header.headerId === parseInt(value));
        if (selectedHeader) {
            setSelectedLedgerAcc(selectedHeader.ledgerAccDtoList[0].ledgerId);
        }
    };

    const handleLedgerAccChange = (value) => {
        setSelectedLedgerAcc(value);
    };
    const handleLedgerAccChangeReport = (value) => {
        setSelectedReport(value);
    };

    const onSwitchChangeFormat = (checked) => {
        setIsExcelLedgerReport(checked);
    };

    const onHandleTrailBalance = (checked) => {
        setIsExcelGLTrialReport(checked);
    };
    const onSwitchChangeFormat2 = (checked) => {
        setIsExcelGLTrialReport(checked);
    };
    const onSwitchChangeFormat3 = (checked) => {
        setIsExcelGLReport(checked);
    };
    const onSwitchChangeFormat4 = (checked) => {
        setIsExcelGenLedgerReport(checked);
    };

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
    };

    const getAllDistricts = () => {
        getAllDistrict().then((res => {
            let data = createDistrictData(res.data);
            setDistrictData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllBranchesByDivAId = () => {
        getDivAreaBranches().then((res => {
            let data = createDivAreaData(res.data);
            setDivAreaData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllDistrictDivisionalBranchesList = () => {
        getDistrictDivisionalBranchDetails().then((res => {
            setDistrictDivisionalBranchData(res.data);
        })).catch((err) => {
            errHandler(err)
        })
    };


    const getAllBranchesbyDistrict = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrictData : decodeToken.districtName;
        if (districtName.length > 0) {
            getAllBranchesByDistrictName(districtName).then((res => {
                let data = createdBranchData(res.data);
                setBranchData(data);
            })).catch((err) => {
                errHandler(err)
            })
        }
    };


    const generateAccountGLReport = () => {
        let data = {
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            selectedDate: date,
            glAccountEnum: glType,
            isExcel: isExcelLedgerReport,
        }
        setLoading(true);
        generateAccountGl(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setLoading(false)
        })

    };

    const generateBranchLedgerReport = () => {
        let data = {
            glAccountEnum: ledgerGlType,
            selectedDate: date,
        }
        setLoading(true);
        generateLedgerBranchReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setLoading(false)
        })

    };

    const generateDistrictWiseBranchLedgerReport = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrictData : decodeToken.districtName;
        let data = {
            selectedDate: date,
            ledgerId: selectedLedgerAcc,
            districtName: districtName,
        }
        setGlLoading(true);
        generateLedgerDistrictReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setGlLoading(false)
        })

    };

    const generateDistrictWiseLedgerReport = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrictData : decodeToken.districtName;
        let data = {
            selectedDate: date,
            districtName: districtName,
            glAccountEnum: glType,
            isExcel: isExcelLedgerReport
        }
        setGlDistrictLoading(true);
        generateLedgerDistrictWiseReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setGlDistrictLoading(false)
        })

    };

    const handleBookEntryListApi = () => {
        if (selectedBranch === "0") {
            generateDistrictBookEntryListReport();

        } else {
            generateBranchWiseLedgerReport();
        }
    }

    const generateBranchWiseLedgerReport = () => {
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            ledgerId: selectedReport,
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            isExcel: isExcelLedgerReport,
        }
        setGlLoading(true);
        generateLedgerBranchWiseReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setGlLoading(false)
        })

    };

    const generateDistrictBookEntryListReport = () => {
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            ledgerId: selectedReport,
            districtName: selectedDistrictData,
            isExcel: isExcelLedgerReport,
        }
        setGlLoading(true);
        generateLedgerBranchWiseReportDistrict(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setGlLoading(false)
        })

    };

    const generateLedgerTrailBalance = () => {
        let selectedBranchId = loginPlaceId === "1" ? decodeToken.branchId : selectedBranch;
        let data = {
            selectedDate: ledgerDate,
            branchId: selectedBranchId,
            isExcel: isExcelGLTrialReport,
            isBeforeDistributeProfit: isChecked
        }
        setLedgerLoding(true);
        getAllTrailBalance(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setLedgerLoding(false)
        })

    };
    const handleGenerateReport = () => {
        if (selectedBranch === "All Branches") {
            generateDistrictWiseLedgerReport();
        } else if (selectedDistrictData === "All Island") {

        } else {
            generateAccountGLReport();
        }
    };


    const getAllLedgerHeaderDetails = () => {
        getAllLedgerHeaders().then((res) => {
            let data = createdData(res.data);
            setHeaderData(data);
        }).catch((err) => {
            errHandler(err)
        });
    };

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (!isInitialMount.current) {
            getAllBranchesbyDistrict();
            setSelectedBranch("");
        } else {
            isInitialMount.current = false;
        }
    }, [selectedDistrictData]);




    useEffect(() => {
        getAllLedgerHeaderDetails();
        getAllDistrictDivisionalBranchesList();
        getAllDistricts();
        if (loginPlaceId === "2") {
            getAllBranchesByDivAId();
            setSelectedDivisionalArea(decodeToken.divAId)
        } else if (loginPlaceId === "4") {
            setSelectedDistrictData(decodeToken.districtName)
        }

    }, [])
    return (
        <>
            <div>
                <h3>General Ledger</h3>
            </div>
            <Collapse className="collapse-report " >
                <PermissionPanel
                    permission="accountGeneralLedger"
                    placeIds={["1", "2"]}
                    header="Account General Ledger Report"
                    key="accountGeneralLedger" className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="GL Type">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleChange}
                                                options={glTypeOption}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Date">
                                            <DatePicker onChange={(date) => setDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateAccountGLReport} disabled={loading} className="generate-btn">
                                                {loading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="accountGeneralLedger"
                    placeIds={["3", "4"]}
                    header="General Ledger Report"
                    key="accountGeneralLedger1"
                    className={`collapse-panel ${loginPlaceId === "3" || loginPlaceId === "4" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDistrictData}
                                                    onChange={handleGlDistrictSelect}
                                                    dataSource={
                                                        filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Select Branch">

                                            <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                <option value="All Branches">All Branches</option>
                                                <Option value="">-- Select --</Option>
                                                {branchData.length > 0 &&
                                                    branchData.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="GL Type">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleChange}
                                                options={glTypeOption}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Date">
                                            <DatePicker onChange={(date) => setDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="To Excel">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeFormat} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={handleGenerateReport} disabled={loading || glDistrictLoading} className="generate-btn">
                                                {loading || glDistrictLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="generalLedgerReportBranchWise"
                    placeIds={["1", "2"]}
                    header="General Ledger Report Branch Wise"
                    key="generalLedgerReportBranchWise"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Header">
                                            <Select value={selectedHeader} onChange={handleHeaderChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select Header --</Option>
                                                {headerData.map((header) => (
                                                    <Option key={header.headerId} value={header.headerId}>
                                                        {header.headerName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        {selectedHeader && (
                                            <Form.Item label="Account">
                                                <Select value={selectedReport} onChange={handleLedgerAccChangeReport} style={{ width: '100%' }}>
                                                    {headerData
                                                        .find((header) => header.headerId === parseInt(selectedHeader))
                                                        .ledgerAccDtoList.map((ledgerAcc) => (
                                                            <Option key={ledgerAcc.legId} value={ledgerAcc.legId}>
                                                                <Tooltip title={`${ledgerAcc.legCode}-${ledgerAcc.legName}`} placement="left">
                                                                    <span>{ledgerAcc.legCode}-{ledgerAcc.legName}</span>
                                                                </Tooltip>
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        )}
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Date Range">
                                            <RangePicker onChange={handleDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateBranchWiseLedgerReport} disabled={glLoading} className="generate-btn">
                                                {glLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="generalLedgerTrailBalance"
                    placeIds={["3", "4", "1", "2"]}
                    header="General Ledger Trail Balance"
                    key="generalLedgerTrailBalance"
                    className={`collapse-panel ${loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "1" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="District">
                                                <AutoComplete
                                                    value={selectedDistrictData}
                                                    onChange={handleGlDistrictSelect}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}

                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    {(loginPlaceId === "3" || loginPlaceId === "4") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Date">
                                            <DatePicker onChange={handleLedgerDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    {(loginPlaceId === "3" || loginPlaceId === "4") && (
                                        <Col span={24}>
                                            <Form.Item label="To Excel">
                                                <Switch defaultChecked={false} onChange={onHandleTrailBalance} />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item>
                                            <Form.Item name={"beforeDistributeProfit"} valuePropName={"checked"} noStyle>
                                                <Checkbox onChange={handleCheckboxChange}>Before Distribute Profit</Checkbox>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateLedgerTrailBalance} disabled={ledgerLoading} className="generate-btn">
                                                {ledgerLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="generalLedgerBranchWiseOpeningBalance"
                    placeIds={["3", "4", "2"]}
                    header="General Ledger Report Ledger Wise excel format"
                    key="generalLedgerBranchWiseOpeningBalance"
                    className={`collapse-panel ${loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <LedgerBranchWise loginPlaceId={loginPlaceId} headerData={headerData} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalId} />
                </PermissionPanel>

                <PermissionPanel
                    permission="bookEntryReport"
                    placeIds={["3", "4", "2", "1"]}
                    header="Book entry report"
                    key="bookEntryReport"
                    className={`collapse-panel`}>
                    <BookEntryList loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalId} branchId={branchId} branchName={branchName} />
                </PermissionPanel>

                <PermissionPanel
                    permission="monitorBookEntry"
                    placeIds={["3", "4", "2", "1"]}
                    header="Monitor Book Entry"
                    key="monitorBookEntry"
                    className={`collapse-panel`}>
                    <BookEntryDetails loginPlaceId={loginPlaceId} />
                </PermissionPanel>

            </Collapse>
            <CustomFooter />
        </>
    )
};
export default GeneralLodger;